import { render, staticRenderFns } from "./PcbLayout.vue?vue&type=template&id=6765210c&scoped=true&lang=html&"
import script from "./PcbLayout.vue?vue&type=script&lang=js&"
export * from "./PcbLayout.vue?vue&type=script&lang=js&"
import style0 from "./PcbLayout.vue?vue&type=style&index=0&id=6765210c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6765210c",
  null
  
)

export default component.exports